import { useState, useRef, useEffect, useCallback } from "react";
import { Grid, TextField } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import BackButton from "components/shared/BackButton";
import { StyledMenuItem, StyledStack, StyledTitle } from "./AddDiscount.style";
import TableCM from "components/shared/Table";
import DrawerCM from "components/shared/Drawer";
import DatePickerCM from "components/shared/DatePicker";
import Icon from "react-multi-date-picker/components/icon";
import GenarateHeadCell from "helper/generate-head-cell";
import { convertDate, DATE_FORMATS } from "helper/date";
import useHttp from "hooks/use-http";
import LoadingCM from "components/shared/Loading";
import { addDiscountRequest, getUsersRequest } from "api/requests";
import PaginationCM from "components/shared/Pagination";
import { PAGINATION_LIMIT } from "constants";
import ReactHookFormSelect from "components/shared/ReactHookFormSelect";
import { dicountSchema } from "validations";
import useSelected from "hooks/use-selected";
import Toast from "helper/toast";
import DeleteModal from "components/shared/Modal/Delete";
import { convertNum } from "helper/convert-num";

const headCells = GenarateHeadCell("users");

const formList = [
  { label: "کد تخفیف", type: "text", id: "code", required: true },
  { label: "مقدار", type: "text", id: "amount", required: true },
  { label: "نوع", id: "type", required: true },
];

export default function AddDiscount() {
  const today = convertDate({
    time: "today",
    format: DATE_FORMATS.faDateTime,
  });
  const datePickerRef = useRef();
  const { request, loading } = useHttp();
  const selectCTX = useSelected();
  const [page, setPage] = useState(1);
  const [users, setUsers] = useState({ data: [], count: 0 });
  const [dateValue, setDateValue] = useState(today);
  const [showSendModal, setshowSendModall] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(dicountSchema),
  });

  const handelShowModal = () => setshowSendModall((state) => !state);

  const handleDateChange = (value) => {
    const date = convertDate({
      time: new Date(value),
      format: DATE_FORMATS.faDateTime,
    });
    setDateValue(date);
  };

  ////////////Form ///////////
  const onSubmit = async (values) => {
    if (
      getValues("type") === "percentage" &&
      convertNum(getValues("amount")) > 100
    ) {
      return Toast({ type: "custom", title: "مقدار درصد باید پایین ۱۰۰ باشد" });
    }
    const res = await request({
      url: addDiscountRequest,
      values: {
        ...values,
        users: selectCTX.selectedItems,
        expires_at: dateValue.enDate,
      },
    });

    if (res) {
      reset({
        code: "",
        amount: "",
      });
      selectCTX.removeItems();
      Toast({ type: "success", title: "ثبت کد تخفیف" });
    }
  };
  const onSubmitAll = async (values) => {
    if (
      getValues("type") === "percentage" &&
      convertNum(getValues("amount")) > 100
    ) {
      handelShowModal();
      return Toast({ type: "custom", title: "مقدار درصد باید پایین ۱۰۰ باشد" });
    }
    const res = await request({
      url: addDiscountRequest,
      values: {
        ...values,
        expires_at: dateValue.enDate,
      },
    });

    handelShowModal();

    if (res) {
      reset({
        code: "",
        amount: "",
      });
      selectCTX.removeItems();
      Toast({ type: "success", title: " ثبت کد تخفیف برای همه" });
    }
  };

  const handelSearch = (e) => getUsers(e);

  const getUsers = useCallback(
    async (search) => {
      const res = await request({
        url: getUsersRequest,
        values: {
          skip: search ? 0 : (page - 1) * PAGINATION_LIMIT,
          limit: search ? 100 : PAGINATION_LIMIT,
          search,
          type: "user",
        },
      });

      if (res) {
        let transformedData = res.data.map((items) => ({
          id: items.id,
          full_name: items.full_name,
          phone_number: items.phone_number,
        }));

        setUsers({ data: transformedData, count: res.count });
      }
    },
    [page, request]
  );

  useEffect(() => {
    getUsers();
  }, [page, getUsers]);

  useEffect(() => {
    selectCTX.removeItems();
    return () => {
      selectCTX.removeItems();
    };
  }, []);

  return (
    <DrawerCM title="ثبت کد تخفیف" onSearch={handelSearch}>
      {loading ? (
        <LoadingCM />
      ) : (
        <Grid container>
          <Grid item mt={3} xs={12}>
            <BackButton />
          </Grid>

          <StyledStack>
            <StyledTitle>ثبت کد تخفیف</StyledTitle>
            <Grid container mt={2}>
              {formList.map((items, index) => (
                <Grid item md={6} xs={12} p={1.5} key={"add-discount" + index}>
                  {items.id === "type" ? (
                    <ReactHookFormSelect
                      id={items.id}
                      label={items.label}
                      variant="outlined"
                      required={items.required}
                      control={control}
                      defaultValue="price"
                      title={items.label}
                    >
                      <StyledMenuItem value="price" selected>
                        تومان
                      </StyledMenuItem>
                      <StyledMenuItem value="percentage">درصد</StyledMenuItem>
                    </ReactHookFormSelect>
                  ) : (
                    <TextField
                      id={items.id}
                      label={items.label}
                      variant="outlined"
                      required={items.required}
                      fullWidth
                      {...register(items.id)}
                      disabled={items.readOnly}
                      error={Boolean(errors[items.id])}
                      helperText={errors[items.id]?.message}
                    />
                  )}
                </Grid>
              ))}
              <Grid item md={6} xs={12} p={1.5}>
                <TextField
                  id="expirationDate"
                  label="تاریخ انقضا"
                  variant="outlined"
                  fullWidth
                  readOnly
                  value={dateValue.faDate}
                  onClick={() => datePickerRef.current.openCalendar()}
                ></TextField>
                <DatePickerCM
                  useref={datePickerRef}
                  value={new Date(dateValue.faDate)}
                  onChange={handleDateChange}
                  render={<Icon size={0} />}
                  type="Date"
                />
              </Grid>
            </Grid>
          </StyledStack>
          <Grid item xs={12} my={2}>
            <TableCM
              title="انتخاب کاربران"
              rows={users.data}
              headCells={headCells}
              isSelectable
              onSubmit={handleSubmit(onSubmit)}
              onDelete={() => selectCTX.removeItems()}
              onSubmitAll={() => {
                if (
                  [
                    getValues("code").trim(),
                    getValues("amount").trim(),
                  ].includes("")
                ) {
                  window.scroll({ top: 0 });
                  return handleSubmit()();
                }
                handelShowModal();
              }}
              page={page}
            />
          </Grid>
          <PaginationCM
            handleChange={(e, val) => setPage(val)}
            page={page}
            count={users.count}
          />

          <DeleteModal
            show={showSendModal}
            onClose={handelShowModal}
            onDelete={handleSubmit(onSubmitAll)}
            title="آیا میخواهد این تخفیف را برای همه اعمال کنید؟"
          />
        </Grid>
      )}
    </DrawerCM>
  );
}
